"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSlotProofHandler = void 0;
const utils_1 = require("../../../utils");
const bignumber_1 = require("@ethersproject/bignumber");
const bytes_1 = require("@ethersproject/bytes");
const base_1 = require("./base");
// prettier-ignore
class SingleSlotProofHandler extends base_1.StrategyHandlerBase {
    constructor() {
        super(...arguments);
        this._TIMESTAMP_TO_ETH_BLOCK_NUMBER_STORE = '_timestamp_to_eth_block_number';
        this._L1_LATEST_BLOCK_STORE = 'latest_processed_block';
    }
    /**
     * Fetches the inputs required to prove a storage key
     * @param contractAddress The address of the contract whose storage is being proven
     * @param slotKey The storage key to prove
     * @param block The block number to prove
     */
    async fetchProofInputs(contractAddress, slotKey, block) {
        const result = await this.defaultProvider.send('eth_getProof', [
            (0, bytes_1.hexZeroPad)(contractAddress, 20),
            [slotKey],
            `0x${block.toString(16)}`, // Block Number
        ]);
        return utils_1.storageProofs.getProofInputs(block, result);
    }
    /**
     * Get the block number for the given timestamp from the block registry. If it has not
     * been populated yet, then query the header store for the latest block number.
     * @param timestamp The unix timestamp
     */
    async getBlockNumberForTimestamp(timestamp) {
        let block = await this.getBlockNumberFromRegistry(timestamp);
        if (!block) {
            block = await this.getLatestBlockNumberFromHeadersStore();
        }
        return block;
    }
    /**
     * Get the block number for the given timestamp from the block registry.
     * @param timestamp The unix timestamp
     */
    async getBlockNumberFromRegistry(timestamp) {
        const key = utils_1.encoding.getStorageVarAddress(this._TIMESTAMP_TO_ETH_BLOCK_NUMBER_STORE, bignumber_1.BigNumber.from(timestamp).toHexString());
        const block = parseInt((await this._starknet.getStorageAt(this._addresses.starknet.blockRegistry, key)).toString(), 16);
        // 1 block offset due to https://tinyurl.com/nzz5dyyx
        return block !== 0 ? block - 1 : block;
    }
    /**
     * Get the latest block number from the header store
     */
    async getLatestBlockNumberFromHeadersStore() {
        const block = parseInt((await this._starknet.getStorageAt(this._addresses.starknet.herodotus.l1HeadersStore, utils_1.encoding.getStorageVarAddress(this._L1_LATEST_BLOCK_STORE))).toString(), 16);
        // 1 block offset due to https://tinyurl.com/nzz5dyyx
        return block - 1;
    }
    /**
     * Get storage hash for the provided account and block number from the fact registry
     */
    async getStorageHash(account, block) {
        const { result } = await this._starknet.callContract({
            contractAddress: this._addresses.starknet.herodotus.factRegistry,
            entrypoint: 'get_account_field',
            calldata: [
                account, String(block), 0, 0
            ],
        });
        if (result.length < 3) {
            return bignumber_1.BigNumber.from(0);
        }
        const [, low, high] = result;
        return bignumber_1.BigNumber.from(utils_1.splitUint256.SplitUint256.fromObj({ low, high }).toString());
    }
}
exports.SingleSlotProofHandler = SingleSlotProofHandler;
